import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { ComplaintsComponent } from './complaints.component';
import { DialogComponent } from './dialog/dialog.component';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';

const routes: Routes = [
    {
        path     : 'complaints',
        component: ComplaintsComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        ComplaintsComponent,
        DialogComponent
    ],
    entryComponents: [DialogComponent],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class ComplaintsModule
{
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/complaints/complaints.module.ts